export function toJSONString(form) {
  const obj = {};
  const elements = form.querySelectorAll('input, select, textarea');
  for (let i = 0; i < elements.length; ++i) {
    const element = elements[i];
    const name = element.name;
    const value = element.value;

    if (name) {
      obj[name] = value;
    }
  }

  return obj;
}


export const defaultUserData = {
  guest_1_first_name: '',
  guest_1_last_name: '',
  guest_2_first_name: '',
  guest_2_last_name: '',
  guest_3_first_name: '',
  guest_3_last_name: '',
  created: new Date(),
  updated: new Date(),
};
